export enum ActionStatus {
  loading = 'loading',
  invalidating = 'invalidating',
  archiving = 'archiving',
  archived = 'archived',
  deleting = 'deleting',
  deleted = 'deleted',
  duplicated = 'duplicated',
  error = 'error',
  idle = 'idle',
}
